import React from 'react'
import { BrowserRouter as Router } from 'react-router'
import { TranslationProvider } from '../../shared/TranslationProvider'
import { QuizProvider } from '../QuizProvider'
import { QuizInner } from '../Index'
import translations from '../locales.json'

const OnboardingReadiness = ({ locale, ...props }) => {
  return (
    <Router>
      <TranslationProvider
        locale={locale || 'en'}
        translations={translations}
        scope={'javascript.components.Quizzes'}
      >
        <QuizProvider {...props}>
          <QuizInner />
        </QuizProvider>
      </TranslationProvider>
    </Router>
  )
}

export default OnboardingReadiness
